module.exports = __webpack_public_path__ + "img/pic_ranking_two.d787a89e.png";